import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { EmbedVideoService } from "ngx-embed-video";
import { VCard, VCardEncoding, VCardFormatter } from "ngx-vcard";
import { AuthServiceLocal } from "../../auth.service";
import { NgxOtpInputConfig } from "ngx-otp-input";
import { saveAs } from 'file-saver';
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  @ViewChild('emailform') emailform: TemplateRef<any>;
  @ViewChild('signupform') signupform: TemplateRef<any>;
  @ViewChild('signUpform') signUpform: TemplateRef<any>;
  @ViewChild('otpModal') otpModal: TemplateRef<any>;
  @ViewChild('passwordModal') passwordModal: TemplateRef<any>;
  @ViewChild('locationModal') locationModal: TemplateRef<any>;
  @ViewChild('popupEpayment') popupEpayment: TemplateRef<any>;
  otpInputConfig: NgxOtpInputConfig = {
    otpLength: 4,
    autofocus: true,
    classList: {
      inputBox: 'my-super-box-class',
      input: 'my-super-class',
      inputFilled: 'my-super-filled-class',
      inputDisabled: 'my-super-disable-class',
      inputSuccess: 'my-super-success-class',
      inputError: 'my-super-error-class',
    },
  };
  otp: string = "";
  isConnection: boolean = false;
  UserId = "";
  userData: any = {};
  isLoading: boolean = false;
  isLoading1: boolean = false;
  isExpanded: boolean = false;
  userForm: FormGroup;
  signForm: FormGroup;
  url: string

  name: string
  emailPattern = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  highlightedLinks = [];
  otherList = [];
  embeddedList: any = []
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  private modalRef: NgbModalRef;
  safeUrl: any;
  iframe_html: any;
  linkList: any = [];
  socialUrls: any;
  // profileLink:any;
  addressurl: any = [];
  emailList: any = [];
  telephoneList: any = [];
  otpData: any = {};
  signUpData: any = {}
  public vCardEncoding: typeof VCardEncoding = VCardEncoding;
  public vCard: VCard;
  public vCardString = VCardFormatter;
  userAgent: any = "";
  UserNameId: any = "";
  socialLinks: any = [];
  optForm: FormGroup;
  passwordForm: FormGroup;
  showPassword: boolean = false;
  passwordPattern = /(?=.*?[a-z])(?=.*?[0-9])(?=.*?[A-Z])(?=.*?[@#$%^&*()|])/
  lat: any;
  lng: any;
  popData:any={};
  textlink:any;
  timeCount:number =30;
  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private authServiec: AuthServiceLocal,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private router: Router,
    private sanitizer: DomSanitizer,
    private embedService: EmbedVideoService,
    private http: HttpClient
  ) {
  }

  ngOnInit(): void {
    this.UserId = this.route.snapshot.params["userId"];
    this.getProfile();
    this.initialiseForms();
    this.passwordStatusForm();
    this.getUserAgent();
   

  }

  getLocation() {
      navigator.geolocation.getCurrentPosition((position: any) => {
        if (position) {
    
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
         
           this.getProfile();
        }
      },
        (error) => {
          this.openModalReset(this.UserId, this.locationModal, '')
        //  alert('Please turn on your location from setting');
        }
        );
  }


  getUserAgent() {
    if (navigator.platform.indexOf("Win") != -1) this.userAgent = "Windows";
    if (navigator.platform.indexOf("Mac") != -1) this.userAgent = "MacOs";
    if (navigator.platform.indexOf("iPhone") != -1) this.userAgent = "iOS";
    if (navigator.platform.indexOf("Android") != -1) this.userAgent = "Android";
    // if (this.userAgent === "iPhone") {
    //   window.open("https://apps.apple.com/us/app/get-wetap/id1660750697");
    // }
    // if (this.userAgent === "Windows" || "MacOs") {
    //   window.open("https://getwetap.com/");
    // }
    // if (this.userAgent === "Android" || this.userAgent === "") {
    //   window.open("https://play.google.com/store/apps/details?id=com.zimblecode.wetap");
    // }
  }
  onShareLinks() {
    const { title, url } = { title: "Wetap", url: 'https://devadminwetap.zimblecode.com/card/' + this.UserId };
    // const files = this.files;
    const toBeShared = {
      title,
      url
    };
    if(this.userData.isPremiumUser){
      if (navigator.share) {
        navigator
          .share({
            ...toBeShared
          })
          .then(() => console.log("Share was successful."))
          .catch((error: DOMException) =>
            console.log(error)
          );
      } else {
        alert("Your browser doesn't support the Share Intent");
      }
    }
    else{
      alert("User don't have Premium account")
    }
   
  }

  locationCheck(value){
    this.modalRef.close();
    this.lat='';
    this.lng='';
    if (this.userData.isLeadCapture == true && this.userData['askLocationOnWeb'] == true ) {
      this.prepareUpdateStatusForm();
      this.openModalReset(this.userData.cardId, this.emailform, '')
    };
    this.getProfile();
  }
  isWebLoction:boolean = true;
  getProfile() {
    this.isLoading = true
    let query = "cardId=" + this.UserId;
    if(this.lat) {
      query = query +'&lat=' + this.lat + '&lng=' + this.lng;
    }
    this.authServiec.getUserProfile(query).subscribe(
      (res) => {
        if (res["message"] == "Success") {
         

          this.userData = res.data;
         
          if (this.userData.userName === "") {
            this.router.navigate(['card/' + this.UserId]);

          }
          else {
            if (this.userData.userName != this.UserId) {
              this.UserId = this.userData.userName;
              this.router.navigate(['card/' + this.UserId]);
            }
          }
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          let array: any = []
          for (let i = 0; i < this.userData.sections.length; i++) {
            for (let j = 0; j < this.userData.sections[i]['list'].length; j++) {
              array.push(this.userData.sections[i]['list'][j])
            }
          }
          // console.log(array,"arr")
          // console.log(this.userAgent)
          array.filter(item=>{
            if(this.userAgent !== "iOS"){
              if(item.webIconAndroid){
                item.webIcon=item.webIconAndroid;
              }
              else{
                item.webIcon=item.webIcon;
              }
            }
            else{
              item.webIcon=item.webIcon;
            }
          });
          array.filter(item=>{
            if(item.isExpandableText === true){
              item.ishighlight=true;
            }
          });
          this.linkList = array;
          // console.log(this.textlink)
          if (this.userData.isDirect === true) {
            array.forEach(element => {
              if (element.isMakeDirect === true) {
                if (element.link.includes("https:")) {
                  this.redirectTo(element.link)
                }
                else {
                  let universalLink;
                  if (this.userAgent === "iOS" || "MacOs") {
                    universalLink = element.info.universalLinkIos + element.link;
                  }
                  if (this.userAgent === "Windows") {
                    universalLink = element.info.universalLinkWeb + element.link;
                  }
                  if (this.userAgent === "Android" || this.userAgent === "") {
                    universalLink = element.info.universalLinkAndroid + element.link;
                  }
                  this.redirectTo(universalLink)
                }
              }
            });
          }
          // console.log(this.linkList,"lkjljklkj");
          this.addressurl = [];
          this.socialUrls = [];
          this.telephoneList = [];
          this.emailList = []
          let proflieListr = []
          console.log('1234',array)
          array.forEach((element) => {
            if (element.title === "Address") {
              this.addressurl.push(
                {
                  "street": element['userTitle']+""+element['link']
                })
            }
            else if (element.title === "Phone number") {
              this.telephoneList.push(element['link'])
            }
            else if (element.title === "Email") {
              this.emailList.push(
                element['link'])
            }
            else {
              this.socialLinks.push(element)
            }
          }
          );
          // console.log('this.socialLinks',this.socialLinks)
          let profileLink = window.location.origin + "/card/" + this.userData['userName']
          // proflieListr.push(profileLink)
          let arra3 = {title : 'ProfileLink', link: profileLink}
          
          this.socialLinks.push(arra3)
          const unique = [...new Set(this.socialLinks.map(item => item.title))]
          unique.map(item => {
            let commonItems = this.socialLinks.filter(x => x.title === item)
            commonItems.map((item, index) => {
              if (index) {
                this.socialUrls[
                  item.title.replace(/\s/g, '') + index] = item.link
              }
              else {
                this.socialUrls[item.title.replace(/\s/g, '')] = item.link;
              }
            })
          });
          //  console.log(this.socialUrls,"links")
          array.forEach(element => {
            if (element['isEmbeddedVideo'] === true) {
              element['url'] = this.embedService.embed(element['link']);
            }

          });
         this.vCard =
            { name: { firstNames: this.userData['cardName'], lastNames: '' }, telephone: this.telephoneList, address: this.addressurl, email: this.emailList, socialUrls: this.socialUrls};
          this.vCardString.getVCardAsString(this.vCard);
          // console.log('testt',this.vCard)
          let newLinks = array.filter(item => item.isEmbeddedVideo == true)
          this.embeddedList = []
          newLinks.forEach(element => {
            this.embeddedList.push(this.embedService.embed(element['link']))
          });

          this.highlightedLinks = array.filter(item => item.ishighlight == true)
          this.otherList = array.filter(item => item.ishighlight == false && item.isEmbeddedVideo == false)
          if (this.userData.isLeadCapture == true && this.userData['askLocationOnWeb'] == false ) {
            this.prepareUpdateStatusForm();
            this.openModalReset(this.userData.cardId, this.emailform, '')
          };
          if(this.userData['askLocationOnWeb'] == true && this.lat == undefined) {
            
            this.getLocation()
          }
        } else {
          this.isLoading = false
        }
        // console.log('this.socialUrls.',this.vCard)
      },
      (err) => {
        this.isLoading = false;
        this.router.navigate(['invalidLink'])
      }
    );
  }
  timserSubsribe:any;
   timerStart(){
    if(this.timeCount == 0) this.timeCount = 30;
   this.timserSubsribe= setInterval(() => {
      this.timeCount = this.timeCount -1;
      // console.log('timeCount',this.timeCount)
      if(this.timeCount == 0) {
        clearInterval(this.timserSubsribe)
      }
    }, 1000);
  }
  openModalReset(row, content, btn) {
    this.prepareUpdateStatusForm();
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
      centered: true,
    };
   
  
    this.UserId = row;
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  initialiseForms() {
    this.signForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      name: ["", [Validators.required]],
      phoneNumber: [""],
      selectedCountryCode:[""],
    })
  }
  passwordStatusForm() {
    this.passwordForm = this.formBuilder.group({
      password: ["", [Validators.required, Validators.pattern(this.passwordPattern), Validators.minLength(8)]],
    });
  }
  prepareUpdateStatusForm() {
    this.userForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      name: ["", [Validators.required]],
      phoneNumber:[""],
      selectedCountryCode:["+91"],
    });
  }

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }
  signUpUser() {
    let req = { ...this.passwordForm.value };
    req['name']= this.namecheck ,
    req['authType'] = "web",
      req['email'] =this.emaildata,
      req['otpToken'] = this.signUpData.token,
      req['isWebUser'] = true;
    this.isLoading = true;
    this.authServiec.signup(req).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] == "Success")) {
          // this._snackBar.open(res.data.message, "", {
          //   duration: 3000,
          //   horizontalPosition: "right",
          //   verticalPosition: "top",
          //   panelClass: ["success"],
          // });
          if(res['isUserExist'] === true){
            this.modalService.dismissAll();
           this.isConnection = true; 
          }
          this.modalService.dismissAll();
          this.finalSignup();
          this.userData.isLeadCapture = false;
        }
      },
      err => {
        this.modalService.dismissAll();
        let data = err.error['data']['response']
        this.signForm.patchValue({
          email: data['email'],
        })

        this.isLoading = false;
      }
    );
  }
 otpcheck: string;
 namecheck: any;
  signup() {
    let req;
    if (this.userForm.value.email === "") {
      req = { ...this.signForm.value }
    }
    else {
      req = { ...this.userForm.value };
    }
    this.PhoneNumber = req['phoneNumber']
    this.countryCode = req['selectedCountryCode']
    this.namecheck= req['name']
    req['userBy'] = this.userData.cardId;
    this.isLoading = true;
    this.emaildata = req['email']
    // console.log('this.emaildata',this.emaildata)
    // console.log('this.req',req['email'])
    this.authServiec.emailCheck(req).subscribe(
      (res) => {
        
        this.isLoading = false;
        if ((res["message"] == "Success")) {
          this._snackBar.open(res.data.message, "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          // console.log(res.data.message , 'r')
          this.modalService.dismissAll();
          this.isConnection = true;
        }
      },
   
      err => {
       // this.modalService.dismissAll();
        let data = err.error['data']['response']
       
        this.signForm.patchValue({
          email: data['email'],
        })
        // this._snackBar.open("Email don't exist Please enter OTP", "", {
        //   duration: 3000,
        //   horizontalPosition: "right",
        //   verticalPosition: "top",
        //   panelClass: ["success"],
        // });
        // this.openModalReset(this.UserId, this.signupform, '');
        this.signupwithEmail()
        this.otpcheck = err.status;
        // console.log('otp check' , this.otpcheck)
        // this.openModalReset(this.UserId, this.otpModal, '');
        this.isLoading = false;
      }
    );
  }
  redirectTo(link) {
    window.open(link, "_self");
  }

  hrefFunction(data) {
    if(data.info.isPopup === true){
      this.popData=data
       this.openModalReset(this.UserId, this.popupEpayment, '')
    }
    else{
 if (data.link.includes("https:")) {
      return data.link
    }
    else {
      let universalLink;
      if (this.userAgent === "iOS"|| "MacOs") {
        universalLink = data.info.universalLinkIos + data.link;
      }
      if (this.userAgent === "Windows") {
        universalLink = data.info.universalLinkWeb + data.link;
      }
      if (this.userAgent === "Android" || this.userAgent === "") {
        universalLink = data.info.universalLinkAndroid + data.link;
      }
      return universalLink;
    }
    }
   

  }
  emaildata : any;
  verifyOtp() {
    let req = { 'otp': parseInt(this.otp) };
    req['type'] = "UR";
  //  req['email'] = this.otpData.email,
   req['email'] = this.userForm.value.email;
    // console.log( this.userForm.value.email)
    // req['email']= this.emailform
    this.isLoading = true;
    this.authServiec.verifyOtp(req).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] == "Success")) {
          this.signUpData = res['data']
          // this._snackBar.open('Otp sent successfully', "", {
          //   duration: 3000,
          //   horizontalPosition: "right",
          //   verticalPosition: "top",
          //   panelClass: ["success"],
          // });
          this.otpcheck = "";
          // console.log('before',this.userForm.value.email)
          this.emaildata = this.userForm.value.email
          this.modalService.dismissAll();
          
          this.openModalReset(this.UserId, this.passwordModal, '');
          // console.log('after',this.userForm.value.email)
        }
      },
      err => {
        this._snackBar.open(err.error.data.message, "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"],
        });
        this.isLoading = false;
      }
    );

  }
  verifyUserExistByEmail() {
    let req = { ...this.signForm.value };
    // req['type'] = "UR";
    this.isLoading = true;
    this.authServiec.verifyEamilExist(req).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] == "Success")) {

          // this.otpData=res['data']['otps']
          this._snackBar.open(res.data.message, "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          }
          );
          if (res.data.isVerify === true) {
            this.modalService.dismissAll();
            this.signup();
          }
          else {
            this.modalService.dismissAll();
            this.signupwithEmail();
          }
        }
      },
      err => {
        this._snackBar.open(err.error.data.message, "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"],
        });
        this.isLoading = false;

      }

    );

  }
  PhoneNumber: any;
  countryCode: any
  finalSignup() {
    let req: any = {};
    req['name'] =  this.namecheck,
    req['phoneNumber'] = this.PhoneNumber,
    req['selectedCountryCode']= this.countryCode
    req['email'] = this.emaildata,
      req['userBy'] = this.userData.cardId;
    this.isLoading = true;
    this.authServiec.emailCheck(req).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] == "Success")) {
          this._snackBar.open(res.data.message, "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          this.modalService.dismissAll();
          this.isConnection = true;
        }
      },
      err => {
        this.modalService.dismissAll();
        // this._snackBar.open(err.data.message, "", {
        //   duration: 3000,
        //   horizontalPosition: "right",
        //   verticalPosition: "top",
        //   panelClass: ["success"],
        // });
        this.isLoading = false;
      }
    );
  }
  signupwithEmail() {
    // let req = { ...this.signForm.value };
 let req = {
  email:this.emaildata,
  type:"UR"
 }
    // req['email'] =this.emaildata;
    // req['type'] = "UR";
    this.isLoading = true;
    this.authServiec.createOtp(req).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] == "Success")) {
          this.otpData = res['data']['otps']
          this._snackBar.open(res.data.message, "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          this.timerStart()
         
          // this.modalService.dismissAll();
          // this.openModalReset(this.UserId, this.otpModal, '');
        }
      },
      err => {
        // this._snackBar.open(err.error.data.message, "", {
        //   duration: 3000,
        //   horizontalPosition: "right",
        //   verticalPosition: "retop",
        //   panelClass: ["success"],
        // });
        this.isLoading = false;
      }
    );
  }
  getUrl(url: any) {
    return this.iframe_html = this.embedService.embed(url);
  }

  private getDismissReason(reason: any): string {
    this.isExpanded = false;
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  signupOpenModal(UserId, signUpform, resetBtn1) {
    this.modalService.dismissAll();
    this.openModalReset(UserId, signUpform, resetBtn1)
  }
  handeOtpChange(value: string[]): void {
    this.otp = value.join("");
  }
  handleFillEvent(value: string): void {
    // console.log(value);

  }
  closeModal() {
    this.modalRef.close();
  }
  back() {
    this.modalRef.close();
    // this.openModalReset(this.UserId, this.signUpform, '');
    this.openModalReset(this.userData.cardId, this.emailform, '')

  }
  copyLink(val: string){
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    alert('Text copied successfully!!')
  }
  openWebsite(){
    window.open('https://getwetap.com/')
  } 
  openWebsiteZimble(){
    window.open('https://zimblecode.com/')
  }

  generateVCF1(data) {
    let vcfContent = `BEGIN:VCARD
VERSION:3.0
N;CHARSET=utf-8:${data.cardName};;;;
FN;CHARSET=utf-8:`;+"\n";
  
    if (data.cardJobTitle) vcfContent += "\nTITLE;CHARSET=utf-8:" + data.cardJobTitle + "\n";
    if (data.cardCompany) vcfContent += "ORG;CHARSET=utf-8:" + data.cardCompany + "\n"
    for (let i = 0; i < data.sections.length; i++) {
      data.sections[i].list.forEach((x) => {
        let type = x.title;
        if (["Phone number", "Number", "Call"].includes(type)) vcfContent += `TEL;TYPE=${x.title}:${x.link}\n`;
        else if (type === "Email") vcfContent += `EMAIL;TYPE=${x.title}:${x.link}\n`;
        else if (type === "Expandable Text") vcfContent += `NOTE;CHARSET=utf-8:${x.link}\n`;
        else if (type === "Address") vcfContent += `ADR;TYPE=${x.title};CHARSET=utf-8:;;${x.link};;;;\n`;
        else vcfContent += `URL;TYPE=${x.title}:${x.link}\n`;
      });
    }
    vcfContent += "URL;TYPE=URL:"+window.location.origin + "/card/" + this.userData['userName'] + "\n";
  //     if (data.profilePic) {
  //       let  base64Img = ""
  //       this.imageUrlToBase64(this.userData.profilePic)
  // .then((base64Data: string) => {
  //   console.log(base64Data); 
  //   base64Img =base64Data;
  //   vcfContent += `PHOTO;ENCODING=b;TYPE=JPEG:${base64Img}\n`;

  //   // Base64 representation of the image
  // })
  // .catch((error) => {
  //   console.error('Error converting image to base64:', error);
  // });
       
  //     }
  
    vcfContent += `END:VCARD`
    return vcfContent;
  }
  downloadVCF() {
    setTimeout(() => {
      const vcfContent = this.generateVCF1(this.userData);
      const blob = new Blob([vcfContent], { type: 'text/vcard;charset=utf-8' });
      saveAs(blob, this.UserId);
    }, 1000);
    
  }
  async imageUrlToBase64(imageUrl: string): Promise<string> {
    const imageData = await this.http.get(imageUrl, { responseType: 'blob' }).toPromise();
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        const base64Data = base64String.split(',')[1];
        resolve(base64Data);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(imageData);
    });
  }
  
}
